export const initAcc = (elem, option) => {

    document.addEventListener("click", function (e) {
        if (!e.target.matches(elem + " .acc-toggle")) return;
        else {
            if (!e.target.parentElement.classList.contains("active")) {
                if (option === true) {
                    var elementList = document.querySelectorAll(
                        elem + " .acc-container"
                    );
                    Array.prototype.forEach.call(elementList, function (e) {
                        e.classList.remove("active");
                    });
                }
                e.target.parentElement.classList.add("active");
            } else {
                e.target.parentElement.classList.remove("active");
            }
        }
    });
}

'use strict';

/**
 * Job Accordion
 */

export const job_detail_accordion = () => {


  const tabItems = document.querySelectorAll(".tab-list .tab-item--term");

  document.querySelector(".tab-list").addEventListener("click", (e) => {
   

    if (e.target.classList.contains("tab-item--term")) {
      e.preventDefault();

      let term = e.target;

      if(term.classList.contains("closed")){
        term.classList.remove("closed");
        term.parentElement.nextElementSibling.setAttribute("hidden", "false");
      }else {
        term.classList.add("closed");
        term.parentElement.nextElementSibling.setAttribute("hidden", "true");
      }

    }
    if(e.target.classList.contains("toggleAll")){
      e.preventDefault();
      // reset items
      if(e.target.textContent.includes('Collapse All')){
        e.target.textContent = 'Expand All';
      }else {
        e.target.textContent = 'Collapse All';
      }

      let panel = document.querySelector('.job-description-panel');
      if(panel.classList.contains('open')){
        panel.classList.remove('open');
        panel.classList.add('collapsed');
        tabItems.forEach((i) => {
          i.classList.add("closed");
          i.parentElement.nextElementSibling.setAttribute("hidden", "true");
        });        
      }else {
        panel.classList.remove('collapsed');
        panel.classList.add('open');
        tabItems.forEach((i) => {
          i.classList.remove("closed");
          i.parentElement.nextElementSibling.setAttribute("hidden", "false");
        }); 
      }

    }

  });
  // END LOGIC FOR TABS

};